import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const MobileDevice: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="M7.91565 2.49609V3.99672C7.89485 4.24926 8.08034 4.47185 8.33249 4.49693H11.6672C11.9194 4.47185 12.1049 4.24926 12.0841 3.99672V2.49609"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33203 15.0008H11.6668"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M13.3329 17.5023H6.66345C5.7426 17.5023 4.99609 16.7558 4.99609 15.835V4.16345C4.99609 3.2426 5.7426 2.49609 6.66345 2.49609H13.3329C14.2538 2.49609 15.0003 3.2426 15.0003 4.16345V15.835C15.0003 16.7558 14.2538 17.5023 13.3329 17.5023Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
